import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpResponse } from '@microsoft/signalr';
import { WhatsappApprovalRequest } from '../models/whatsapp-template/whatsapp-approval-request.interface';

@Injectable({
  providedIn: 'root',
})
export class WhatsappService {
  private getHostUrl = () => {
    const url = environment.scheme + environment.host + environment.port + '/';
    return url;
  };

  private readonly sendForApprovalUrl = `${this.getHostUrl()}api/v${environment.version
    }/whatsapp/`;

  constructor(private http: HttpClient) {
  }

  sendForApproval(approvalRequest: WhatsappApprovalRequest): Observable<string> {
    return this.http.post<string>(this.sendForApprovalUrl, approvalRequest, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

}
